import { createStore } from 'vuex';

export default createStore({
  state: {
    remainingTime: 3600 * 2, // 倒计时初始时间，单位为秒
    interval: null,
    currentTable: JSON.parse(localStorage.getItem('currentTable')) || { path: 'exam' },
    currentExam: null,
    joined_exam: JSON.parse(localStorage.getItem('joined_exam')) || {}
  },
  mutations: {
    decrementTime(state) {
      if (state.remainingTime > 0) {
        state.remainingTime--;
      } else {
        clearInterval(state.interval);
        state.interval = null;
      }
    },
    setInterval(state, interval) {
      state.interval = interval;
    },
    clearInterval(state) {
      clearInterval(state.interval);
      state.interval = null;
    },
    updateCurrentTable(state, payload) {
      state.currentTable = payload;
      localStorage.setItem('currentTable', JSON.stringify(payload)); // 更新localStorage
    },
    setCurrentExamId(state, exam) {
      state.currentExam = exam;
    },
    setJoinedExam(state, exam) {
      state.joined_exam = exam;
      localStorage.setItem('joined_exam', JSON.stringify(exam));
    }
  },
  actions: {
    startCountdown({ commit, state }) {
      if (!state.interval) {
        const interval = setInterval(() => {
          commit('decrementTime');
        }, 1000);
        commit('setInterval', interval);
      }
    },
    stopCountdown({ commit }) {
      commit('clearInterval');
    },
    setCurrentTable({ commit }, payload) {
      commit('updateCurrentTable', payload);
    },
    updateCurrentExam({ commit }, exam) {
      commit('setCurrentExamId', exam);
    },
    updateJoinedExam({ commit }, exam) {
      commit('setJoinedExam', exam);
    }
  },
  getters: {
    formattedTime(state) {
      const hours = String(Math.floor(state.remainingTime / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((state.remainingTime % 3600) / 60)).padStart(2, '0');
      const seconds = String(state.remainingTime % 60).padStart(2, '0');
      return `${hours}时 ${minutes}分 ${seconds}秒`;
    },
    getCurrentTable: state => state.currentTable,
    getCurrentExam: (state) => state.currentExam,
    getJoinedExam: state => state.joined_exam
  },
});
